// write a react component that displays a banner, this component should take a prop for the ran override as a string or array of strings
// the banner should display the ran override message if it exists
// the message should be "The RAN option is locked to {RAN_LABELS[ranOverride]} for {selectedAssessmentTagObject.label}" if there is a single ran override
// the message should be "The RAN options are locked to {ranOverrideMessages} for {selectedAssessmentTagObject.label}" if there are multiple ran overrides

import React from 'react';
import { RAN_LABELS } from '../../../../../../constants/assessmentConfigPageConstants';
import Banners from '../../../blocks/Banners';

const RANOverrideMessageBanner = ({ ranOverride, selectedConfigTagLabel }) => {
  if (!ranOverride) return null;

  // If there is a single RAN override, display the message with the single RAN override
  if (typeof ranOverride === 'string') {
    return (
      <Banners type="info">
        The RAN option is locked to {RAN_LABELS[ranOverride]} for {selectedConfigTagLabel}
      </Banners>
    );
  }

  // If there are multiple RAN overrides, display the message with all the RAN overrides
  if (Array.isArray(ranOverride)) {
    const ranOverrideMessages = ranOverride.map(ran => RAN_LABELS[ran]);
    return (
      <Banners type="info">
        The RAN options are locked to {ranOverrideMessages.join(', ')} for {selectedConfigTagLabel}
      </Banners>
    );
  }

  return null;
}

export default RANOverrideMessageBanner;